import {
  Home, Car, Trees, Fence as FenceIcon, Waves, Square, Footprints,
  Building2, Layers, HelpCircle, Sun, ParkingCircle,
} from "lucide-react";

/**
 * Iter57.4 — Per-category icon mapping for measurement cards.
 *
 * Kept small and readable — one icon per MEASUREMENT_CATEGORIES key. The
 * icon component is used in the workspace card list and the
 * PropertyMeasurementsSection so the visual language stays consistent
 * across surfaces.
 */
const MAP = {
  roof: Home,
  house: Building2,
  driveway: Car,
  deck: Layers,
  patio: Square,
  sidewalk: Footprints,
  landscape_area: Trees,
  landscape_volume: Trees,
  fence: FenceIcon,
  gutter: Waves,
  parking_lot: ParkingCircle,
  solar: Sun,
  other: HelpCircle,
};

/**
 * Renders the appropriate icon for a category key. Uses HelpCircle when
 * the key is unknown or falsy, so the card visual never breaks.
 *
 * @param {{ category?: string, className?: string, "data-testid"?: string }} props
 */
export default function CategoryIcon({ category, className, ...rest }) {
  const Icon = MAP[category] || HelpCircle;
  return <Icon className={className} aria-hidden {...rest} />;
}
